/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react';
import Chip from '@mui/material/Chip';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  FormControl,
  Select,
  MenuItem,
  TextField,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  TablePagination,
  IconButton,
  Button,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Alert,
  Tooltip,
  Divider,
} from '@mui/material';
import 'leaflet/dist/leaflet.css';
import { FaTrashAlt, FaEdit, FaInfo } from 'react-icons/fa';
import Lokasi from '../lokasi';

import '../../../componen/css/Dashboard.css';
import axios from 'axios';
import useSWR, { mutate } from 'swr';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { apiHost } from '../../../utils/apiHost';
import { WARNA_STATUS } from '../../absensi/pengaturan/bersama';
import { teksShiftBaris } from '../../../utils/rekapPresensi';


const getApiBaseUrl = () => {
  const protocol = window.location.protocol === "https:" ? "https" : "http";
  const baseUrl = apiHost().replace(/^https?:\/\//, "");
  return `${protocol}://${baseUrl}`;
};

const fetcher = (url) => axios.get(url, { withCredentials: true }).then((res) => res.data);

const ActionButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(1),
}));

export const DataPresensi = () => {
  const { user, token } = useSelector((state) => state.auth);

  const [totalCabang, setTotalCabang] = useState(0);

  const [attendanceData, setAttendanceData] = useState([]);
  const [totalAbsensi, setTotalAbsensi] = useState(0);
  const [todayAbsensi, setTodayAbsensi] = useState(0);
  const [absensiCurrentPage, setAbsensiCurrentPage] = useState(0);
  const [absensiRowsPerPage, setAbsensiRowsPerPage] = useState(10);
  
  const [absensiSearchUsername, setAbsensiSearchUsername] = useState('');
  const [absensiFilterTanggal, setAbsensiFilterTanggal] = useState('');
  const [absensiFilterCabang, setAbsensiFilterCabang] = useState('');

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editAttendanceData, setEditAttendanceData] = useState(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [detailAttendanceData, setDetailAttendanceData] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const { data: cabangList, error: cabangError } = useSWR(`${getApiBaseUrl()}/cabang`, fetcher);
  
  const attendanceUrl = `${getApiBaseUrl()}/absensiall/get?page=${absensiCurrentPage + 1}&limit=${absensiRowsPerPage}` +
    (absensiSearchUsername ? `&username=${absensiSearchUsername}` : '') +
    (absensiFilterTanggal ? `&tanggal=${absensiFilterTanggal}` : '') +
    (user?.role === 'superadmin' && absensiFilterCabang ? `&cabangUuid=${absensiFilterCabang}` : '');

  const { data: absensiResponse, error: absensiError } = useSWR(user ? attendanceUrl : null, fetcher);

  useEffect(() => {
    if (absensiResponse) {
      setAttendanceData(absensiResponse.data);
      setTotalAbsensi(absensiResponse.totalData);
      
      const today = new Date();
      const todayDateString = today.toISOString().slice(0, 10);
      const todayCount = absensiResponse.data.filter(absen =>
        new Date(absen.tgl_absensi).toISOString().slice(0, 10) === todayDateString
      ).length;
      setTodayAbsensi(todayCount);
    }
  }, [absensiResponse]);

  const handleChangePage = (event, newPage) => {
    setAbsensiCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setAbsensiRowsPerPage(parseInt(event.target.value, 10));
    setAbsensiCurrentPage(0);
  };
  
  const handleOpenEditModal = (absen) => {
    setEditAttendanceData({
      id: absen.uuid,
      username: absen.User?.username,
      tanggal: new Date(absen.tgl_absensi).toISOString().slice(0, 10),
      jam_masuk: absen.jam_masuk,
      jam_keluar: absen.jam_keluar,
    });
    setIsEditModalOpen(true);
  };
  
  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    setEditAttendanceData(null);
    setError('');
    setSuccess('');
  };

  // const handleEditChange = (e) => {
  //   const { name, value } = e.target;
  //   setEditAttendanceData((prev) => ({ ...prev, [name]: value }));
  // };
  const handleEditChange = (e) => {
  const { name, value } = e.target;
  const formattedValue = (name === 'jam_masuk' || name === 'jam_keluar') && value.length === 5
    ? `${value}:00`
    : value;

  setEditAttendanceData((prev) => ({
    ...prev,
    [name]: formattedValue,
  }));
};

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      await axios.put(
        `${getApiBaseUrl()}/absensi/${editAttendanceData.id}`,
        {
          // jam_masuk: editAttendanceData.jam_masuk,
          // jam_keluar: editAttendanceData.jam_keluar,
          jam_masuk: editAttendanceData.jam_masuk?.substring(0, 5),
      jam_keluar: editAttendanceData.jam_keluar?.substring(0, 5),
          tgl_absensi: editAttendanceData.tanggal,
          
        },
        
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );
      

      setSuccess('Data presensi berhasil diperbarui!');
      handleCloseEditModal();
      mutate(attendanceUrl);
    } catch (err) {
      console.error(err);
      setError('Gagal memperbarui data presensi. Pastikan semua field terisi dengan benar.');
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDeleteDialog = (uuid) => {
    setDeleteId(uuid);
    setIsDeleteDialogOpen(true);
  };
  const formatTime = (time) => {
  if (!time) return '';
  return time.length === 5 ? `${time}:00` : time;
};


  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
    setDeleteId(null);
    setError('');
    setSuccess('');
  };

  const handleDelete = async () => {
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      await axios.delete(`${getApiBaseUrl()}/absensi/${deleteId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      setSuccess('Data presensi berhasil dihapus!');
      handleCloseDeleteDialog();
      mutate(attendanceUrl);
    } catch (err) {
      console.error(err);
      setError('Gagal menghapus data presensi.');
    } finally {
      setLoading(false);
    }
  };

const handleOpenDetailModal = async (uuid) => {
  setLoading(true);
  try {
    const response = await axios.get(`${getApiBaseUrl()}/absensiall/${uuid}`, {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = response.data;

    let latitude = null;
    let longitude = null;

    if (data.lokasi_masuk) {
      const [lat, long] = data.lokasi_masuk.split(',');
      latitude = parseFloat(lat);
      longitude = parseFloat(long);
    }

    setDetailAttendanceData({
      ...data,
      latitude,
      longitude,
    });

    setIsDetailModalOpen(true);
  } catch (err) {
    console.error("Error fetching detail:", err);
    setError('Gagal mengambil data detail presensi.');
  } finally {
    setLoading(false);
  }
};

  
  const handleCloseDetailModal = () => {
    setIsDetailModalOpen(false);
    setDetailAttendanceData(null);
    setError('');
    setSuccess('');
  };

  // Parsing koordinat untuk peta
  const parseCoordinates = (lokasi) => {
    if (!lokasi) return null;
    const [lat, lon] = lokasi.split(',').map(Number);
    if (isNaN(lat) || isNaN(lon)) return null;
    return { latitude: lat, longitude: lon };
  };

  const locationMasuk = detailAttendanceData ? parseCoordinates(detailAttendanceData.lokasi_masuk) : null;
  const locationKeluar = detailAttendanceData ? parseCoordinates(detailAttendanceData.lokasi_keluar) : null;

  if (cabangError || absensiError) {
    console.error("Error loading data:", cabangError || absensiError);
    return <Typography>Error loading data. Please check console for details.</Typography>;
  }
  if (!cabangList || !absensiResponse) return <Typography>Loading...</Typography>;

  return (
    <Box sx={{ flexGrow: 1, p: 3, backgroundColor: '#f4f6f8', minHeight: '100vh' }}>
      
     

      {/* Attendance List Section */}
      <Card sx={{ mt: 3, padding: 2 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Daftar Presensi
        </Typography>
        {absensiResponse.statusTersedia === false && (
          <Alert severity="warning" sx={{ mb: 2 }}>Status dan shift belum bisa dihitung saat ini. Data presensi tetap benar; muat ulang halaman untuk mencoba lagi.</Alert>
        )}
        <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
          <TextField
            label="Cari Username"
            variant="outlined"
            size="small"
            value={absensiSearchUsername}
            onChange={(e) => setAbsensiSearchUsername(e.target.value)}
            sx={{ flexGrow: 1, minWidth: '180px' }}
          />
          <TextField
            label="Filter Tanggal"
            type="date"
            variant="outlined"
            size="small"
            value={absensiFilterTanggal}
            onChange={(e) => setAbsensiFilterTanggal(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ flexGrow: 1, minWidth: '180px' }}
          />
          {user?.role === 'superadmin' && (
            <FormControl size="small" sx={{ flexGrow: 1, minWidth: '180px' }}>
              <InputLabel>Filter Cabang</InputLabel>
              <Select
                value={absensiFilterCabang}
                label="Filter Cabang"
                onChange={(e) => setAbsensiFilterCabang(e.target.value)}
              >
                <MenuItem value="">Semua Cabang</MenuItem>
                {cabangList && cabangList.data && cabangList.data.map((cabang) => (
                  <MenuItem key={cabang.uuid} value={cabang.uuid}>
                    {cabang.namacabang}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>No</TableCell>
                <TableCell>Username</TableCell>
                <TableCell>Cabang</TableCell>
                <TableCell>Tanggal Absensi</TableCell>
                <TableCell>Waktu Masuk</TableCell>
                <TableCell>Waktu Pulang</TableCell>
                <TableCell>Shift</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Aksi</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {attendanceData.length > 0 ? (
                attendanceData.map((absen, index) => (
                  <TableRow key={absen.uuid}>
                    <TableCell>{absensiCurrentPage * absensiRowsPerPage + index + 1}</TableCell>
                    <TableCell>{absen.User?.username || 'N/A'}</TableCell>
                    <TableCell>{absen.User?.Cabang?.namacabang || 'N/A'}</TableCell>
                    <TableCell>{new Date(absen.tgl_absensi).toLocaleDateString('id-ID')}</TableCell>
                    <TableCell>{absen.jam_masuk || 'Belum Absen'}</TableCell>
                    <TableCell>
                      {absen.jam_keluar || 'Belum Pulang'}
                      {/* Absen dari aplikasi saat server mati (dikirim belakangan) */}
                      {absen.dikirim_offline ? (
                        <Chip size="small" label="Offline" title="Absen dibuat saat server tidak terjangkau dan dikirim belakangan" sx={{ ml: 1, height: 20, fontSize: 11 }} />
                      ) : null}
                      {absen.jam_perlu_dicek ? (
                        <Chip size="small" color="warning" label="Jam perlu dicek" title="Jam HP berubah saat offline; jam absen dikoreksi otomatis oleh server" sx={{ ml: 1, height: 20, fontSize: 11 }} />
                      ) : null}
                    </TableCell>
                    <TableCell>{teksShiftBaris(absen.statusKehadiran)}</TableCell>
                    <TableCell>
                      {/* Status dihitung server sesuai Pengaturan Absensi cabang (jadwal shift, toleransi, libur, izin/sakit/cuti) */}
                      {absen.statusKehadiran ? (
                        <>
                          <Chip size="small" color={WARNA_STATUS[absen.statusKehadiran.status] || 'default'} label={absen.statusKehadiran.label} />
                          {absen.statusKehadiran.telatMenit > 0 ? (
                            <Typography variant="caption" display="block" color="text.secondary">Terlambat {absen.statusKehadiran.telatMenit} menit</Typography>
                          ) : null}
                          {absen.statusKehadiran.pulangCepatMenit > 0 ? (
                            <Typography variant="caption" display="block" color="text.secondary">Pulang cepat {absen.statusKehadiran.pulangCepatMenit} menit</Typography>
                          ) : null}
                        </>
                      ) : '-'}
                    </TableCell>
                    <TableCell>
                      {user?.role === 'superadmin' && (
                        <>
                          <Tooltip title="Edit">
                            <IconButton color="primary" onClick={() => handleOpenEditModal(absen)}>
                              <FaEdit />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Hapus">
                            <IconButton color="error" onClick={() => handleOpenDeleteDialog(absen.uuid)}>
                              <FaTrashAlt />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}
                      {(user?.role === 'superadmin' || user?.role === 'admin') && (
                         <Tooltip title="Detail">
                           <IconButton color="info" onClick={() => handleOpenDetailModal(absen.uuid)}>
                             <FaInfo />
                           </IconButton>
                         </Tooltip>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    Tidak ada data presensi ditemukan.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalAbsensi}
          rowsPerPage={absensiRowsPerPage}
          page={absensiCurrentPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Baris per halaman:"
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} dari ${count !== -1 ? count : `lebih dari ${to}`}`
          }
        />
      </Card>

      {/* Modal Edit */}
      <Dialog open={isEditModalOpen} onClose={handleCloseEditModal} fullWidth>
        <DialogTitle>Edit Data Presensi</DialogTitle>
        <DialogContent>
          {loading && <CircularProgress size={24} sx={{ display: 'block', margin: 'auto' }} />}
          {error && <Alert severity="error">{error}</Alert>}
          {success && <Alert severity="success">{success}</Alert>}
          {editAttendanceData && (
            <Box component="form" onSubmit={handleEditSubmit} sx={{ mt: 2 }}>
              <TextField
                name="username"
                label="Username"
                value={editAttendanceData.username}
                fullWidth
                margin="normal"
                disabled
              />
              <TextField
                name="tanggal"
                label="Tanggal Absensi"
                type="date"
                value={editAttendanceData.tanggal}
                onChange={handleEditChange}
                fullWidth
                margin="normal"
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                name="jam_masuk"
                label="Waktu Masuk"
                type="time"
                value={editAttendanceData.jam_masuk || ''}
                onChange={handleEditChange}
                fullWidth
                margin="normal"
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                name="jam_keluar"
                label="Waktu Pulang"
                type="time"
                value={editAttendanceData.jam_keluar || ''}
                onChange={handleEditChange}
                fullWidth
                margin="normal"
                InputLabelProps={{ shrink: true }}
              />
              <DialogActions>
                <Button onClick={handleCloseEditModal} color="primary" disabled={loading}>
                  Batal
                </Button>
                <Button type="submit" color="primary" variant="contained" disabled={loading}>
                  Simpan
                </Button>
              </DialogActions>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {/* Dialog Konfirmasi Hapus */}
      <Dialog open={isDeleteDialogOpen} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Konfirmasi Hapus</DialogTitle>
        <DialogContent>
          <Typography>Apakah Anda yakin ingin menghapus data presensi ini?</Typography>
          {loading && <CircularProgress size={24} sx={{ mt: 2 }} />}
          {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ mt: 2 }}>{success}</Alert>}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary" disabled={loading}>
            Batal
          </Button>
          <Button onClick={handleDelete} color="error" variant="contained" disabled={loading}>
            Hapus
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal Detail Presensi */}
      <Dialog open={isDetailModalOpen} onClose={handleCloseDetailModal} maxWidth="sm" fullWidth>
        <DialogTitle>Detail Presensi</DialogTitle>
        <DialogContent>
          {loading && <CircularProgress size={24} sx={{ display: 'block', margin: 'auto' }} />}
          {error && <Alert severity="error">{error}</Alert>}
          {detailAttendanceData && (
            <Box>
              
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="h6" gutterBottom>Absen Masuk</Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Typography variant="body1">
                    <strong>Jam Masuk:</strong> {detailAttendanceData.jam_masuk || 'Belum Absen'}
                  </Typography>
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="body1"><strong>Lokasi Masuk:</strong></Typography>
                    {locationMasuk ? (
                      <Box sx={{ mt: 1, border: '1px solid #ccc', borderRadius: '4px', overflow: 'hidden' }}>
                        {/* Menampilkan komponen Lokasi dengan props latitude dan longitude */}
                        <Lokasi latitude={locationMasuk.latitude} longitude={locationMasuk.longitude} cabang={detailAttendanceData.User?.Cabang} tinggi={220} />
                      </Box>
                    ) : (
                      <Typography variant="body2" color="textSecondary">Lokasi tidak tersedia.</Typography>
                    )}
                  </Box>
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="body1"><strong>Foto Masuk:</strong></Typography>
                    {detailAttendanceData.foto_masuk ? (
                      <Box
                        component="img"
                        src={`${getApiBaseUrl()}/uploads/absensi/${detailAttendanceData.foto_masuk}`}
                        alt="Foto Masuk"
                        sx={{
                          maxWidth: '100%',
                          maxHeight: '300px',
                          display: 'block',
                          mt: 1,
                          borderRadius: 1,
                        }}
                      />
                    ) : (
                      <Typography variant="body2" color="textSecondary">Foto tidak tersedia.</Typography>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="h6" gutterBottom>Absen Pulang</Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Typography variant="body1">
                    <strong>Jam Keluar:</strong> {detailAttendanceData.jam_keluar || 'Belum Pulang'}
                  </Typography>
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="body1"><strong>Lokasi Pulang:</strong></Typography>
                    {locationKeluar ? (
                     <Box sx={{ mt: 1, border: '1px solid #ccc', borderRadius: '4px', overflow: 'hidden' }}>
  <Lokasi latitude={locationKeluar.latitude} longitude={locationKeluar.longitude} cabang={detailAttendanceData.User?.Cabang} tinggi={220} />
</Box>

                    ) : (
                      <Typography variant="body2" color="textSecondary">Lokasi tidak tersedia.</Typography>
                    )}
                  </Box>
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="body1"><strong>Foto Pulang:</strong></Typography>
                    {detailAttendanceData.foto_keluar ? (
                      <Box
                        component="img"
                        src={`${getApiBaseUrl()}/uploads/absensi/${detailAttendanceData.foto_keluar}`}
                        alt="Foto Pulang"
                        sx={{
                          maxWidth: '100%',
                          maxHeight: '300px',
                          display: 'block',
                          mt: 1,
                          borderRadius: 1,
                        }}
                      />
                    ) : (
                      <Typography variant="body2" color="textSecondary">Foto tidak tersedia.</Typography>
                    )}
                  </Box>
                </Grid>
              </Grid>
              <Box sx={{ mt: 3 }}>
                <Typography variant="h6" gutterBottom>Informasi Karyawan</Typography>
                <Divider sx={{ mb: 2 }} />
                <Typography variant="body1">
                  <strong>Nama:</strong> {detailAttendanceData.User?.username || 'Tidak Diketahui'}
                </Typography>
                <Typography variant="body1" sx={{ mt: 1 }}>
                  <strong>Cabang:</strong> {detailAttendanceData.User?.Cabang?.namacabang || 'Tidak Diketahui'}
                </Typography>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDetailModal} color="primary">Tutup</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default DataPresensi;